import { EditorView } from '@uiw/react-codemirror';
import { themeObject, themeObject as theme } from 'lib/util/themes/godzilla';
export const sharedStyles = {
    plusIcon: {
        backgroundColor: theme?.palette.primary.main,
        color: theme?.palette.primary.contrastText,
        fontSize: '25px',
        ml: 1,
        p: 0,
        marginTop: 'auto',
        marginBottom: 'auto',
        boxShadow:
            '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    },
    error: {
        color: theme.palette.error.light,
    },
    dataGridWrapper: {
        '& .MuiDataGrid-columnHeaders': {
            background: '#E7ECEE',
            fill: '#E7ECEE',
            stroke: '#6F858C',
            strokeWeight: '2px',
            textTransform: 'uppercase',
            color: theme.palette.grayScale[800],
            m: 0,
            px: 2,
            minHeight: '40px !important',
            maxHeight: '40px !important',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            fontFamily: 'Open Sans !important',
            fontSize: '12px',
            lineHeight: '18px',
            letterSpacing: '0.5px',
            fontWeight: 'Bold !important',
            Size: '12',
        },
        '& .MuiDataGrid-row': {
            px: 2,
            borderBottom: '1px solid #D2DBDE',
            fontFamily: "'Red Hat Text'",
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '19px',
            color: theme.palette.grayScale[700],
        },
        '& .MuiDataGrid-columnSeparator': {
            display: 'none !important',
        },
        '& .MuiDataGrid-virtualScroller': {
            overflow: 'hidden',
            marginTop: '15px',
        },
    },
    dataGrid: {
        border: '2px solid #D2DBDE',
        backgroundColor: 'white',
        borderRadius: '10px',
        stroke: theme.palette.grayScale[200],
        strokeWidth: '2px',
        color: theme.palette.grayScale[700],
    },
    removeTableFocus: {
        '.MuiDataGrid-cell:focus': {
            outline: 'none',
        },
        '.MuiDataGrid-cell': { cursor: 'pointer' },
        '.MuiDataGrid-cell--withRenderer': { cursor: 'pointer' },
    },
    formStrokeColor: {
        stroke: '#47515A',
        color: theme.palette.grayScale[700],
    },
};

export const CodeMirrorStyles = EditorView.baseTheme({
    '.cm-scroller': {
        '&::-webkit-scrollbar': { width: '8px', height: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
    },
    '&.cm-editor.cm-focused': {
        outline: 'none',
    },
});

export const autoCompleteStyles = {
    width: '100%',
    '& .MuiFormControl-root': {
        width: '100%',
        '& .MuiInputBase-root': {
            '& .MuiChip-root': {
                maxWidth: '422px',
            },
        },
    },
};

export const ContractsSharedStyles = {
    tabsStyles: {
        minHeight: 'unset',
        alignItems: 'center',
        '& .MuiTabs-scroller': {
            '& .MuiTabs-flexContainer': {
                '& .MuiButtonBase-root': {
                    height: '32px',
                    my: '0 !important',
                },
            },
        },
    },
    tabsContainerStyles: {
        mb: '5px',
    },
    tabItemStyles: {
        minHeight: '0',
        m: '6px !important',
    },
    iconStyle: {
        height: '22.86px',
        width: '24px',
        padding: '3px',
        opacity: '.8',
        borderRadius: '16px',
        backgroundColor: themeObject.palette.primary[100],
        color: themeObject.palette.grayScale[700],
    },
    chainSelectContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%',
    },
    contractsSelectFieldMenuItemStyles: {
        width: '212px',
    },
    globalMenuItemTextStyles: {
        width: '100%',
        textWrap: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
};

export const globalEllipsisTextStyles = {
    width: '100%',
    textWrap: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

export const draggablePanelStyles = {
    panelContainerStyles: {
        height: '100%',
        position: 'relative',
        mt: '5px',
        '&:before': {
            content: '""',
            height: '4.5px',
            width: '55px',
            backgroundColor: themeObject.palette.grayScale[300],
            position: 'absolute',
            transform: 'translateX(-50%)',
            left: '50%',
            top: '-5px',
        },
        '&:after': {
            content: '""',
            backgroundColor: themeObject.palette.grayScale[300],
            position: 'absolute',
            transform: 'translateX(-50%)',
            left: '50%',
            top: '2px',
            height: '4.5px',
            width: '55px',
        },
    },
    panelResizeHandleStyles: {
        cursor: 'row-resize',
    },
};

export const ellipsifyTextInTwoLines = {
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'wrap',
};
